import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
import moment from "moment";
Vue.use(Vuex)

const state = {
    sysSetList: [],
    certificate: [],
    backupList: [],
}

const mutations = {
    SET_CERTIFICATE_DETAILS(state, data) {
        state.certificate = data
    },
    CLEAR_BACKUP_STATE(state) {
        state.backupList = [];
    },
    SET_BACKUP_DETAILS(state, backupData) {
        var tData = {};
        var parseData = backupData.message;
        if (Object.keys(state.backupList).length == 0) {
            tData[backupData.accountId + '-backupList'] = parseData;
            state.backupList = tData;
        } else {
            Vue.set(state.backupList, backupData.accountId + '-backupList', parseData);
        }
    },
}

const actions = {
    clearBackupState({
        commit,
        dispatch
    }) {
        commit('CLEAR_BACKUP_STATE')
    },
    systemSettingsSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/index/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    factoryResetSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/factory_reset', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    rebootSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/reboot/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    shutdownSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/halt/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    installUpdatesSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/update_action', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    systemCertificates({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/system_tools/certificates_list")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    commit('SET_CERTIFICATE_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    mapDomainCertificates({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/mapDomainCertificates', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchBackupDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/system_tools/backup/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    commit('SET_BACKUP_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    dwnldBackupSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/backup/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    uploadCertificatesSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios
                .post("/system_tools/uploadCertificates", postData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    restoreSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/backup/true', postData)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveFtpBackSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/ftpSubmit', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveGDriveBackSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/googledriveSubmit', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveAmazonBackSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/amazonS3_Submit', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    downloadBackupSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/download_backup/1', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    pushBackupSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/push_backup_files', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    renewSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/system_tools/renew_submit', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    console.log(response.data);
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}

const getters = {
    systemCertificateGetter: state => {
        return state.certificate;
    },
    getBackupDetailsGetters: state => {
        return state.backupList;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}